export enum ViewerType {
  Native = 1,
  ARender = 2,
  OnlyOfficeViewer = 3,
}
